export default __webpack_public_path__ + "static/cndf-keynote-a45f49f2cf293dcfb9db2b10735a41f0.png";